import {SchemaFieldFilterFormSkeletonProps} from 'search/filters/base/SchemaFieldFilterFormSkeleton';
import {Filter, FilterKey} from 'search/SearchConstants';
import {ButtonSize} from 'ui-library/buttons/Button';

import {FilterOption} from './FilterComponents';

export interface FilterGroup {
  name?: string;
  filterOptions: Array<FilterOption>;
}

export interface BaseFilterFormProps {
  buttonSize: ButtonSize;
  dropdownToggleText?: string;
  filterGroups?: Array<FilterGroup>;
  isActive?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  invalidMessage?: string | null;
  onChangeFilterKey?: (value: FilterKey) => void;
  selectedFilterKey?: FilterKey;
  prefinalizedFilters?: Array<Filter>;
  // Signifies if the filter has been modified since the user opened the filter form. This will be
  // set to true whenever the user adds or modifies a filter, and marked false when they apply a secondary
  // filter, or close a primary filter dropdown.
  isDirty?: boolean;
  dependencies?: Array<Filter>;
  // If set, the user should not be able to remove the filter. To prevent edits to the filter it may
  // be necessary to edit the corresponding filter form to respect the `locked` prop.
  locked?: boolean;
}

export const BASE_FILTER_FORM_PROP_NAMES: Array<keyof BaseFilterFormProps> = [
  'buttonSize',
  'dropdownToggleText',
  'filterGroups',
  'isActive',
  'isDisabled',
  'isLoading',
  'invalidMessage',
  'onChangeFilterKey',
  'selectedFilterKey',
  'dependencies',
  'locked',
];

export enum FilterStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface DateAndDatetimeSchemaFieldFilterFormProps
  extends Omit<SchemaFieldFilterFormSkeletonProps, 'valueNode'> {
  onChangeValue: (value: string) => void;
  value: string;
}
